import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { showDialog } from "@widgets/CommonDialog";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnTab from "@shared/components/SnTab";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import {
  CellValueChangedEvent,
  SnGridRef,
} from "@shared/components/GridV2/SnGridTypes";
import { RowNode } from "ag-grid-community";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_PRD_MRE_REG_001_POP_02 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    const { userInfo } = global();

    const searchRef = useRef<any>(null);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
      grid3: React.createRef(),
    });
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
      grid3: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
      grid3: [],
    });

    const [gridFocus1, setGridFocus1] = useState(false);
    const [gridFocus2, setGridFocus2] = useState(false);
    const [gridFocus3, setGridFocus3] = useState(false);

    const [selectedTab, setSelectedTab] = useState<string>("1");
    const isSyncingCheckbox = useRef(false);
    const [originFormControlData, setOriginFormControlData] = useState<any[]>(
      []
    );
    const [popupParent, setPopupParent] = useState<any>(null);
    const _cdBiz = selectedData?.cd_biz;

    const today = new Date();
    const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
      .toString()
      .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
    const firstDayOfMonth = `${today.getFullYear()}${(today.getMonth() + 1)
      .toString()
      .padStart(2, "0")}01`;
    const getGridCurrent = (key: string): SnGridRef => {
      const grid = gridRefs.current[key]?.current;
      if (!grid) {
        throw new Error(`Grid '${key}' is not mounted yet`);
      }
      return grid;
    };

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        let checkValidity = true;
        let selectedRowsH: any[] = [];
        switch (selectedTab) {
          case "1":
            selectedRowsH = getGridCurrent("grid1")?.getCheckedRows() || [];
            break;
          case "2":
            selectedRowsH = getGridCurrent("grid2")?.getCheckedRows() || [];
            break;
          case "3":
            selectedRowsH = getGridCurrent("grid3")?.getCheckedRows() || [];
            break;
        }
        return selectedRowsH;
      },
      getOkayData: () => {
        let rows: any[] = [];

        if (selectedTab === "1") {
          const checkedrows = getGridCurrent("grid1")?.getCheckedRows() || [];

          rows = checkedrows.map((row: any, index: number) => ({
            cd_firm: row.cd_firm,
            cd_biz: selectedData?.cd_biz,
            no_line: index + 1,
            cd_item: row.cd_item,
            qt: row.qt_wo,
            dt_start: row.dt_start,
            dt_end: row.dt_end,
            dt_dlv_plan: row.dt_end,
            cd_pjt: row.cd_pjt,
          }));
        } else if (selectedTab === "2") {
          const checkedrows = getGridCurrent("grid2")?.getCheckedRows() || [];

          rows = checkedrows.map((row: any, index: number) => ({
            cd_firm: row.cd_firm,
            cd_biz: selectedData?.cd_biz,
            no_line: index + 1,
            cd_item: row.cd_item,
            qt: selectedData?.check === "Y" ? row.qt : row.qt_so,
            dt_start: row.dt_so,
            dt_end: row.dt_dlv,
            dt_dlv_plan: row.dt_dlv,
            no_so: row.no_so,
            no_line_so: row.no_line,
            cd_pjt: row.cd_pjt,
          }));
        } else if (selectedTab === "3") {
          const displayedNodes: any[] = [];
          gridRefs.current["grid3"].current.forEachFilteredNode(
            (node: RowNode) => {
              displayedNodes.push(node);
            }
          );

          for (let i = 0; i < displayedNodes.length; i++) {
            const data = displayedNodes[i].data;

            if (!data.cd_item) {
              return {
                closeFlag: false,
                msgType: "alert",
                msgText: "품목을 입력해 주세요",
              };
            }
            if (!data.dt_dlv_plan) {
              return {
                closeFlag: false,
                msgType: "alert",
                msgText: "납기일을 입력해 주세요",
              };
            }

            if (data.qt === null || data.qt === undefined || data.qt === "") {
              return {
                closeFlag: false,
                msgType: "alert",
                msgText: "수량을 입력해 주세요",
              };
            }
          }

          rows = displayedNodes
            .filter((row: any) => row.data?.cd_item)
            .map((row: any, index: number) => ({
              cd_firm: userInfo?.cd_firm,
              cd_biz: selectedData?.cd_biz,
              no_line: index + 1,
              cd_item: row.data.cd_item,
              qt: row.data.qt,
              dt_dlv_plan: row.data.dt_dlv_plan,
            }));
        }
        return {
          rtnData: [rows],
        };
      },
    }));

    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_PRD_MRE_REG_001_POP_02",
            {}
          );
          const mergedData: any = {
            ...rtn.formData,
            ...selectedData,
            dt_from: firstDayOfMonth,
            dt_to: todayform,
          };
          //setFormControlData(rtn.formControlData);
          setOriginFormControlData(rtn.formControlData);
          const filtered = rtn.formControlData.filter(
            (item: any) =>
              item.nm_label === "지시기간" || item.nm_label === "프로젝트(지시)"
          );

          setFormControlData(filtered);
          setFormData(mergedData);
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
            grid3: rtn.grid.grid3,
          });
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    useEffect(() => {
      if (selectedTab === "1") {
        getGridCurrent("grid1")?.selectAndFocusRow(0);
        setGridFocus1(false);
      } else if (selectedTab === "2") {
        getGridCurrent("grid2")?.selectAndFocusRow(0);
        setGridFocus2(false);
      } else if (selectedTab === "3") {
        getGridCurrent("grid3")?.selectAndFocusRow(0);
        setGridFocus3(false);
      }
    }, [gridFocus1, gridFocus2, gridFocus3]);

    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          // 🔥 탭별 API 분기
          let apiId = "";

          switch (selectedTab) {
            case "1":
              apiId = "sn_prd_mre_reg_001_pop_02_01";
              break;
            case "2":
              apiId = "sn_prd_mre_reg_001_pop_02_02";
              break;
            case "3":
              apiId = "sn_prd_mre_reg_001_pop_02_03"; // 필요하면
              break;
            default:
              return;
          }

          const params = {
            id: apiId,
            params: {
              ...searchRef.current.getFormdata(),
              cd_biz: selectedData?.cd_biz,
            },
          };

          getGridCurrent("grid1").resetUpdate();
          getGridCurrent("grid2").resetUpdate();
          getGridCurrent("grid3").resetUpdate();

          const data: any = await fnGetDataSet(params);

          if (selectedTab === "1") {
            setDataSources({
              grid1: data[0] || [],
              grid2: [],
              grid3: [],
            });
          } else if (selectedTab === "2") {
            setDataSources({
              grid1: [],
              grid2: data[0] || [],
              grid3: [],
            });
          } else if (selectedTab === "3") {
            setDataSources({
              grid1: [],
              grid2: [],
              grid3: data[0] || [],
            });
          }
          switch (selectedTab) {
            case "1":
              getGridCurrent("grid1")?.selectAndFocusRow(0);
              break;
            case "2":
              getGridCurrent("grid2")?.selectAndFocusRow(0);
              break;
            case "3":
              getGridCurrent("grid3")?.selectAndFocusRow(0);
              break;
          }
        } catch (error: any) {
          showDialog("error", error.message);
        }
      };

      fetchdatasource();
    };

    const onAddRow = () => {
      try {
        gridRefs.current["grid3"].current?.stopEditing();
        return gridRefs.current["grid3"].current?.addRow({});
      } catch (error: any) {}
    };

    const onDeleteRow = async () => {
      if (gridRefs.current["grid3"].current?.getDisplayedRowCount() < 1) return;

      gridRefs.current["grid3"].current?.deleteSelectedRows();
    };

    const onTabChanged = (index: string) => {
      setSelectedTab(index);
      changeFormByTab(index);
      setTimeout(() => {
        if (index === "1") getGridCurrent("grid1")?.selectAndFocusRow(0);
        else if (index === "2") getGridCurrent("grid2")?.selectAndFocusRow(0);
        else if (index === "3") getGridCurrent("grid3")?.selectAndFocusRow(0);
      }, 50);
    };

    const changeFormByTab = (tab: string) => {
      if (!originFormControlData) return;

      let filtered = [];

      if (tab === "1") {
        filtered = originFormControlData.filter(
          (item) =>
            item.nm_label === "지시기간" || item.nm_label === "프로젝트(지시)"
        );
      } else if (tab === "2") {
        filtered = originFormControlData.filter(
          (item) =>
            item.nm_label !== "지시기간" && item.nm_label !== "프로젝트(지시)"
        );
      } else if (tab === "3") {
        filtered = [];
      }

      setFormControlData(filtered);
    };

    const onGrid3BtnsClick = async (id: string) => {
      if (id == "addRow") {
        onAddRow();
      }
      if (id == "deleteRow") {
        onDeleteRow();
      }
    };

    const onCellValueChanged = async (event: CellValueChangedEvent) => {
      if (!event) return;
      const colId = event.colId;
      const rowData = event.rowData;

      if (colId === "dt_dlv_plan") {
        const rowCount =
          gridRefs.current["grid3"].current.getDisplayedRowCount();
        if (rowCount === 1) return;
        if (!rowData.dt_dlv_plan) return;

        let apply = false;
        gridRefs.current["grid3"].current?.forEachFilteredNode(
          (node: RowNode) => {
            if (
              node.data[colId] === "" ||
              node.data[colId] === null ||
              node.data[colId] === undefined
            )
              apply = true;
          }
        );
        if (!apply) return;

        const confirm = await showDialog(
          "confirm",
          "일괄적용하시겠습니까?(비어있는 칸이 채워집니다.)"
        );

        if (confirm) {
          gridRefs.current["grid3"].current?.forEachFilteredNode(
            (node: RowNode) => {
              if (
                node.data.dt_dlv_plan === "" ||
                node.data.dt_dlv_plan === null ||
                node.data.dt_dlv_plan === undefined
              ) {
                node.setDataValue("dt_dlv_plan", rowData.dt_dlv_plan);
              }
            }
          );
        }
      }
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
        },
        grid3: {
          columns: columns.grid3,
          dataSource: dataSources.grid3,
          events: {
            onBtnAddClick: onGrid3BtnsClick,
            onBtnDeleteClick: onGrid3BtnsClick,
            onCellValueChanged: onCellValueChanged,
          },
        },
      }),
      [columns, dataSources]
    );

    return (
      <div className="flex flex-col h-full overflow-hidden">
        <div className="flex-1 overflow-hidden">
          <SnTab
            titles={["작업지시", "수주", "Simulation"]}
            width={"100%"}
            onTabChanged={onTabChanged}
            body={[
              <div className="flex flex-col h-full space-y-1.5 overflow-hidden">
                <div className="flex-shrink-0">
                  <SearchPanel
                    ref={searchRef}
                    data={formData}
                    controls={formControlData}
                    popupRef={ref}
                  />
                </div>
                <div className="flex-shrink-0 text-center">
                  <SnSearchBtn
                    text={"조회"}
                    onClick={onSearch}
                    sx={{ width: 80, marginTop: 1.5 }}
                    spinner={true}
                  />
                </div>
                <div className="flex-1 overflow-hidden">
                  <SnGrid
                    ref={gridRefs.current["grid1"]}
                    columnConfig={grids.grid1.columns}
                    rowData={grids.grid1.dataSource}
                    etcProps={{
                      rowSelection: "multiple",
                      ischeckboxSelection: true,
                    }}
                  />
                </div>
              </div>,

              <div className="flex flex-col h-full overflow-hidden space-y-1.5">
                <div className="flex-shrink-0">
                  <SearchPanel
                    ref={searchRef}
                    data={formData}
                    controls={formControlData}
                    popupRef={ref}
                  />
                </div>
                <div className="flex-shrink-0 text-center">
                  <SnSearchBtn
                    text={"조회"}
                    onClick={onSearch}
                    sx={{ width: 80, marginTop: 1.5 }}
                    spinner={true}
                  />
                </div>
                <SnGrid
                  ref={gridRefs.current["grid2"]}
                  columnConfig={grids.grid2.columns}
                  rowData={grids.grid2.dataSource}
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                  }}
                />
              </div>,

              <div className="flex flex-col h-full space-y-1.5 overflow-hidden">
                <div className="flex-shrink-0">
                  <SearchPanel
                    ref={searchRef}
                    data={formData}
                    controls={formControlData}
                    popupRef={ref}
                  />
                </div>
                <div className="flex-shrink-0 text-right">
                  <SnSearchBtn
                    text={"행추가"}
                    onClick={() => {
                      onGrid3BtnsClick("addRow");
                    }}
                    sx={{ width: 80, marginTop: 1.5 }}
                    spinner={true}
                  />
                  <SnSearchBtn
                    text={"행삭제"}
                    onClick={() => {
                      onGrid3BtnsClick("deleteRow");
                    }}
                    sx={{ width: 80, marginTop: 1.5 }}
                    spinner={true}
                  />
                </div>
                <div className="flex-1 overflow-hidden">
                  <SnGrid
                    ref={gridRefs.current["grid3"]}
                    columnConfig={grids.grid3.columns}
                    rowData={grids.grid3.dataSource}
                    etcProps={{
                      rowSelection: "multiple",

                      entertoAddrow: true,
                    }}
                    events={grids.grid3.events}
                  />
                </div>
              </div>,
            ]}
          />
        </div>
      </div>
    );
  }
);

export default SN_PRD_MRE_REG_001_POP_02;
